(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('DocumentApprovalController', DocumentApprovalController);

    DocumentApprovalController.$inject = ['$uibModalInstance', '$translate', 'entity', 'Document', 'CurrencyUtils'];

    function DocumentApprovalController($uibModalInstance, $translate, entity, Document, CurrencyUtils) {
        var vm = this;

        vm.document = entity;
        vm.approving = false;
        vm.statement = null;
        vm.locale = null;
        vm.clear = clear;
        vm.confirmApproval = confirmApproval;
        vm.getCurrency = CurrencyUtils.getCurrency;

        // The wording is fetched rather than composed here, for the same reason the external dialog
        // fetches it: one server-side renderer produces both the sentence shown and the sentence
        // stored on the evidence row, so the two cannot drift apart. Until it arrives the Approve
        // button stays disabled - nobody accepts text they were not shown.
        //
        // The interface language is sent, unlike on the external path where the recipient is
        // anonymous and the server default applies. An approver reading English must not have a
        // Portuguese sentence recorded against them on a document kept ten years.
        Document.approvalStatementById({ id: vm.document.id, locale: $translate.use() })
            .$promise.then(function (result) {
                vm.statement = result.statement;
                vm.locale = result.locale;
            });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmApproval(id) {
            if (vm.approving) {
                return;
            }
            vm.approving = true;

            // locale is not part of the URL template, so $resource sends it as a query parameter.
            // It is the locale the server actually rendered in, not the one we asked for.
            Document.approve(
                { id: id, locale: vm.locale || $translate.use() },
                function () {
                    vm.approving = false;
                    $uibModalInstance.close(true);
                },
                function () {
                    vm.approving = false;
                    $uibModalInstance.dismiss('failed');
                });
        }
    }
})();
